import { render, staticRenderFns } from "./horizontal-tabs-component.vue?vue&type=template&id=2c3d3e99&scoped=true&"
import script from "./horizontal-tabs-component.vue?vue&type=script&lang=ts&"
export * from "./horizontal-tabs-component.vue?vue&type=script&lang=ts&"
import style0 from "./horizontal-tabs-component.vue?vue&type=style&index=0&id=2c3d3e99&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c3d3e99",
  null
  
)

export default component.exports